import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { deleteToken, setToken } from '../../helpers/localstorage-helper';
import { AuthService } from '../../services/auth.service';
import { AbstractPage } from '../abstract-page';

@Component({
  selector: 'je-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent extends AbstractPage {
  loginForm: FormGroup;
  hiddenPassword = true;

  constructor(
    fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
  ) {
    super();
    this.loginForm = fb.group({
      email: 'julius@ecsi.io',
      password: 'pass',
    });
  }

  public submit() {
    firstValueFrom(
      this.authService.login(
        this.loginForm.value.email,
        this.loginForm.value.password,
      ),
    ).then(
      (response) => {
        setToken(response.token);

        this.router.navigate(['/admin/accounts']);
      },
      (error: HttpErrorResponse) => {
        deleteToken();
      },
    );
  }
}
